import { NavMain } from "@/app/ui/NavMain";
import { NavUser } from "@/app/ui/NavUser";
import { PracticeSwitcher } from "@/app/ui/PracticeSwitcher";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/shared/ui/sidebar";
import { type ComponentProps } from "react";

export function AppSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <PracticeSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        {/* <div className="flex items-center justify-between px-2 py-2">
          <SidebarTrigger className="h-7 w-7" />
        </div> */}
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}